import { Component, computed, inject, input, type OnInit } from '@angular/core';
import { TypedComponentRendering } from '@core/jss-models';
import {
  CalculateComponentContent,
  type CalculateComponentRendering,
} from '@innogy/become-a-customer/shared/interfaces';
import type { CalculateState } from '@innogy/become-a-customer/state';
import {
  addCalculateRenderingAction,
  calculateFormLoadedAction,
  calculateFormSubmitAction,
  calculateQuestionnaireOpenModalAction,
  clearFunnelSettings,
  doubleMeterFormControlId,
  getCalculateViewModel,
  getFunnelSettings,
  houseNumberAdditionFormControlId,
  resetHousenumberExtensionAction,
  setBACFunnelStepAction,
  submitAlternateAddressAction,
} from '@innogy/become-a-customer/state';
import { Store } from '@ngrx/store';
import { DisableAction, SetValueAction } from 'ngrx-forms';

import { scToCalculateContentMapper } from '../calculate.mapper';

@Component({
  selector: 'wl-calculate-container',
  templateUrl: './calculate-container.component.html',
  styleUrls: ['./calculate-container.component.scss'],
})
export class CalculateContainerComponent implements OnInit {
  readonly store$ = inject(Store<CalculateState>);

  readonly rendering =
    input<TypedComponentRendering<CalculateComponentRendering>>();
  readonly content = input<CalculateComponentContent>();
  readonly isInModal = input<boolean>(false);

  readonly viewModel = this.store$.selectSignal(getCalculateViewModel);
  readonly funnelSettings = this.store$.selectSignal(getFunnelSettings);

  readonly usageWizard = computed(() => this.funnelSettings().usageWizard);

  readonly computedContent = computed(() => {
    // Refactor this to linkedSignal in Angular 19
    const content = this.content();
    const rendering = this.rendering();
    return (
      content ?? (rendering ? scToCalculateContentMapper(rendering) : undefined)
    );
  });

  ngOnInit() {
    if (!this.isInModal()) {
      this.store$.dispatch(clearFunnelSettings());
    }

    this.dispatchAttachRendering();
    this.bootstrapCalculateForm();
    this.dispatchSetFunnelStep();

    if (this.content()?.enableDoubleMeterCheckbox) {
      this.store$.dispatch(new SetValueAction(doubleMeterFormControlId, true));
    }
  }

  submit() {
    this.store$.dispatch(calculateFormSubmitAction());
  }

  openModal(gasHidden: boolean) {
    this.store$.dispatch(calculateQuestionnaireOpenModalAction({ gasHidden }));
  }

  submitAlternateAddress() {
    this.store$.dispatch(submitAlternateAddressAction());
  }

  hideManualHouseNumberInput() {
    this.store$.dispatch(resetHousenumberExtensionAction());
  }

  private bootstrapCalculateForm() {
    this.store$.dispatch(new DisableAction(houseNumberAdditionFormControlId));
    this.store$.dispatch(calculateFormLoadedAction());
  }

  private dispatchAttachRendering() {
    const rendering = this.rendering();
    if (rendering) {
      this.store$.dispatch(addCalculateRenderingAction({ rendering }));
    }
  }

  private dispatchSetFunnelStep() {
    this.store$.dispatch(setBACFunnelStepAction({ step: 'Calculate' }));
  }
}
